import React from 'react'
import { BrowserRouter, Route, Routes} from 'react-router-dom'
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Kaiwa from './pages/Kaiwa';
import Search from './pages/Search'
import About from './pages/About';


function App() {
  return (
    <div className="container-xxl">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/search" element={<Search />} />
          <Route exact path="/kaiwa/:id" element={<Kaiwa />} />
          <Route exact path="/about" element={<About />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
